export default {
  de: {
    title: 'Stammdaten',
    citizens: 'Einwohner',
    district: 'Bezirk',
    electiondate: 'Letzte GR-Wahl',
    gkz: 'GKZ',
    highestOffice: 'Höchstes Amt',
    members: 'Mitglieder',
    membersAverageAge: 'Mitglieder Ø-Alter',
    officials: 'SPÖ Gemeinderäte*rätinnen',
    officialsAverageAge: 'SPÖ Gemeinderat*rätin Ø-Alter',
    officialsFemale: 'SPÖ Gemeinderätinnen',
    officialsFemalePercent: 'SPÖ-GR Frauenanteil',
    officialsMale: 'SPÖ Gemeinderäte',
    officialsMalePercent: 'SPÖ-GR Männeranteil',
  },
};
